/**
 * GENERATED by scripts/generate-seo-manifest.js — do not edit by hand.
 *
 * Maps a duplicate-slug path to the URL that should absorb its ranking signals. Paths absent from
 * this map are their own canonical.
 */

const CANONICAL_OVERRIDES = {
  '/cs2': '/counter-strike-2',
  '/cs2/accounts': '/counter-strike-2/accounts',
  '/cs2/boosting': '/counter-strike-2/boosting',
  '/cs2/items': '/counter-strike-2/items',
  '/warcraft/accounts': '/world-of-warcraft/accounts',
  '/warcraft/boosting': '/world-of-warcraft/boosting',
  '/warcraft/items': '/world-of-warcraft/items',
  '/warcraft/top-ups': '/world-of-warcraft/top-ups',
};

module.exports = { CANONICAL_OVERRIDES };
